import { useCallback, useState } from "react";

const useMediaModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpenVideo = useCallback(
    (video: string) => {
      handleOpenModal();
    },
    [handleOpenModal]
  );

  return { isOpen, handleOpenModal, handleCloseModal, onOpenVideo };
};

export default useMediaModal;
